import z from 'zod';

export const PagingSchema = z.object({
  currentPageNumber: z.number(),
  totalPagesNumber: z.number(),
  pageSize: z.number(),
  totalCount: z.number()
});

export type Paging = z.infer<typeof PagingSchema>;
